"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _AccountAvatar = _interopRequireDefault(require("../AccountAvatar/AccountAvatar"));
var _ActivityItem = _interopRequireDefault(require("./ActivityItem.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// COMPONENTS

// ASSETS

var ActivityItem = function ActivityItem(_ref) {
  var user = _ref.user,
    message = _ref.message,
    date = _ref.date,
    avatar = _ref.avatar;
  var classes = (0, _ActivityItem.default)();
  var userLetter = user.substring(0, 1);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.activity
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    mr: 2
  }, /*#__PURE__*/_react.default.createElement(_AccountAvatar.default, {
    letter: userLetter,
    src: avatar || '',
    alt: user
  })), /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "h5",
    className: classes.user
  }, user), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "p",
    className: classes.message
  }, message), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "span",
    className: classes.date
  }, date)));
};
var _default = ActivityItem;
exports.default = _default;